import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, LOCALE_ID } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthComponent } from './layouts/auth/auth.component';
import { ErrorsModule } from './errors/errors.module';
import { HTTP_INTERCEPTORS, HttpClientModule, HttpClient } from '@angular/common/http';
import { AuthModule } from './auth/auth.module';
import { HttpService } from './services/http-service/http.service';
import { StorageService } from './services/storage-service/storage.service';
import { UsersService } from './services/users-service/users.service';
import { HttpRequestInterceptor } from './services/http-service/http-request.interceptor';
import { SharedModule } from './shared/shared.module';
import { MainComponent } from './layouts/main/main.component';
import { registerLocaleData} from '@angular/common';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import localeDE from '@angular/common/locales/de';
import { AuthService } from './services/auth-service/auth.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

registerLocaleData(localeDE, 'de');

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    AuthComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    ErrorsModule.forRoot(),
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
	AuthModule,
	TranslateModule.forRoot({
		loader: {
			provide: TranslateLoader,
			useFactory: HttpLoaderFactory,
			deps: [HttpClient]
		}
	}),
	FontAwesomeModule,
  ],
  providers: [
	{provide: LOCALE_ID, useValue: 'de-DE'},
	AuthService,
    HttpService,
    StorageService,
    UsersService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpRequestInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
